import { useTypedDispatch, useTypedSelector } from "@/redux/helpers/hooks";
import { ICartItemProps } from "../../cartInterface";
import { useEffect, useState } from "react";
import useDebouncedValue from "@/lib/helpers/hooks/useDebouncedValue";
import { updateCartItem } from "@/redux/slices/user/thunks/updateCartItem";
import { getCart } from "@/redux/slices/user/thunks/getCart";
import { IncrementButton } from "@/template/components";

const VoipUserCount = ({
  item,
  reviewOrder,
  isPaymentReceipt,
}: Partial<ICartItemProps>) => {
  const dispatch = useTypedDispatch();
  const user = useTypedSelector((state) => state.user.user);
  const quantity =
    item?.type?.name === "VoIP Plan Change"
      ? user?.active_users
      : isPaymentReceipt
        ? item?.quantity
        : item.period;

  const [userCount, setUserCount] = useState(quantity);
  const debouncedUserCount = useDebouncedValue(userCount, 500);
  const isPositive = (val: number | string) => {
    const numericValue = parseInt(val as string);
    return !isNaN(numericValue) && numericValue > 0;
  };

  useEffect(() => {
    if (debouncedUserCount !== quantity && isPositive(debouncedUserCount)) {
      dispatch(
        updateCartItem({
          id: item.id,
          slug: `/svc/cart/item/${item.id}`,
          data: {
            action: "change_period",
            period: debouncedUserCount,
          },
        })
      ).then(() => dispatch(getCart()));
    }
  }, [debouncedUserCount]);

  const handleSetUserCount = (val: number | string) => {
    const min = 1;
    setUserCount(Math.max(min, Number(val)));
  };

  return (
    <>
      <IncrementButton
        type="number"
        value={userCount}
        item={item}
        disabled={item?.type?.name === "VoIP Plan Change" || reviewOrder}
        setValue={handleSetUserCount}
        style={{
          marginLeft: "auto",
        }}
        max={49}
      />
    </>
  );
};

export default VoipUserCount;
